// extracted by mini-css-extract-plugin
module.exports = {"payment_method":"PaymentMethod_payment_method__YHyI3","row":"PaymentMethod_row__SlU-5","tooltip":"PaymentMethod_tooltip__15SgJ"};